// ====================================================================
// FRONTEND API CONFIGURATION - TEMPORARY BROWSER-BASED
// ====================================================================
// TEMPORARY: Using browser-based API calls for MVP deployment
// TODO: Migrate to Next.js with secure server-side API routes
// ====================================================================

export const API_CONFIG = {
  // OpenAI Configuration - SERVER-SIDE ONLY via /api/openai-chat
  openai: {
    apiKey: '', // REMOVED - API key is NEVER exposed to browser. All calls go through /api/openai-chat
    model: "gpt-3.5-turbo",
    maxTokens: 1000,
    temperature: 0.2, // LOW temperature for consistent, deterministic responses
  },
  
  // Weather API Configuration
  weather: {
    apiKey: process.env.REACT_APP_WEATHER_API_KEY || '',
    baseUrl: "https://api.weatherapi.com/v1",
  },
  
  // Supabase Configuration
  // Safe to expose - uses Row Level Security (RLS) for protection
  // Note: Full Supabase config is in src/config/supabase.ts
};

// ====================================================================
// OpenAI is NOW SECURE!
// ====================================================================
// OpenAI calls now go through /api routes (Vercel serverless functions)
// API key is server-side only in Vercel environment variables
// Frontend calls /api/openai-* endpoints, which proxy to OpenAI
// No API key exposure to browser! ✅
// ====================================================================

// ====================================================================
// SETUP INSTRUCTIONS
// ====================================================================
// 
// LOCAL DEVELOPMENT:
// 1. Copy env.example to .env.local
// 2. Fill in your API keys in .env.local
// 3. Restart npm start
//
// PRODUCTION (Vercel):
// 1. Go to Vercel Dashboard → Settings → Environment Variables
// 2. Add: REACT_APP_OPENAI_API_KEY
// 3. Add: REACT_APP_WEATHER_API_KEY (if using weather features)
// 4. Redeploy
//
// IMPORTANT: .env.local is gitignored and will NEVER be committed!
// ====================================================================
